import React, { type Ref } from 'react';
import { Button } from '@shared/components';
import type { SmriqLastCompletedServiceSelection } from '../../../types/smriq.types';
import { lastCompletedServiceRecap } from '../../../utils/lastCompletedServiceRecap';

interface SmriqLastCompletedServiceSummaryProps {
    className?: string;
    selection: SmriqLastCompletedServiceSelection | null;
    onEdit?: () => void;
    editButtonRef?: Ref<HTMLButtonElement>;
}

/** Stands in for the last completed service form once a plan is generated: a one-line recap of
 *  the service it was generated with, plus an Edit affordance to change it. */
export const SmriqLastCompletedServiceSummary: React.FC<SmriqLastCompletedServiceSummaryProps> = ({
    className,
    selection,
    onEdit,
    editButtonRef,
}) => (
    <div className={`bg-mp-surface rounded-xl flex items-center justify-between gap-4 ${className ?? ''}`}>
        <div className="flex flex-wrap items-baseline gap-x-2">
            <h3 className="text-base font-semibold text-mp-foreground">Last Completed Service</h3>
            <span className="text-xs text-mp-muted">
                {lastCompletedServiceRecap(selection)}
            </span>
        </div>
        {onEdit && (
            <Button ref={editButtonRef} type="button" size="sm" variant="outline" onClick={onEdit}>
                Edit last service
            </Button>
        )}
    </div>
);
